module.exports = __webpack_public_path__ + "img/xiangmu2.8e217df3.png";